import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Accordion, { AccordionItem } from '../@base/Accordion';
import Button from '../@base/Button';
import Input from '../@base/Input';
import TextArea from '../@base/TextArea';
import { getParameter } from './Commons';

import styles from './SharedStyle.module.css';
import componentsType from '../Component/ComponentType';

const optionList = {
  label: '',
  value: '',
};

/** Componente que renderiza lista de opções para resposta automática */
const OptionsListInput = (props) => {
  const { options } = props;
  const optionsCount = options.length - 1;

  const onChangeHandler = (e, key, index) => {
    const { value } = e.target;
    const optionsChanged = [...options];
    optionsChanged[index][key] = value;
    props.updateOptions(optionsChanged);
  };

  const onDeleteHandler = (index) => {
    const optionsChanged = [...options];
    delete optionsChanged[index];
    props.updateOptions(optionsChanged);
  };

  return (
    <div className="item-list option">
      <div className="options-list">
        <div>
          <div />
          <div>Rótulo:</div>
          <div>Valor:</div>
          <div />
        </div>

        {options && options.map((el, i) => (
          <div key={i}>
            <div>{i < optionsCount && i + 1}</div>
            <div>
              <Input
                value={el.label}
                onChange={(e) => onChangeHandler(e, 'label', i)}
                placeholder={`Digite rótulo da ${i !== 0 ? 'nova ' : ''}opção`}
              />
            </div>
            <div>
              <Input
                value={el.value}
                onChange={(e) => onChangeHandler(e, 'value', i)}
                placeholder={`Digite valor da ${i !== 0 ? 'nova ' : ''}opção`}
              />
            </div>
            <div>
              {i < optionsCount
                && (
                  <Button
                    small
                    circle
                    title="Apagar opção"
                    onClick={() => onDeleteHandler(i)}
                  >
                    <span>
                      <i className="fa fa-times" aria-hidden="true" />
                    </span>
                  </Button>
                )}
            </div>
          </div>
        ))}

      </div>
      <div />
    </div>
  );
};

/** Componente de resposta automática e assunto desconhecido */
const AutomaticReply = (props) => {
  if (!props.component.parameters) return null;

  const parameterList = props.component.parameters;
  const type = props.component.typeElement.id;
  const isUnknowItent = type === componentsType.ASSUNTO_DESCONHECIDO.id;

  const commands = getParameter(parameterList, 'commandreplier.commands');
  const inputJson = getParameter(parameterList, isUnknowItent ? 'unknown-intent.input.json'
    : 'commandreplier.input.json');

  /** Avalia se deve renderizar cada campo do visualJson conforme args do parametro * */
  const shouldRenderInputJsonText = (inputJson.parameter.args === undefined
    || inputJson.parameter.args === null)
    || inputJson.parameter.args.indexOf('text') >= 0;
  const shouldRenderInputJsonOptions = (inputJson.parameter.args === undefined
    || inputJson.parameter.args === null)
    || inputJson.parameter.args.indexOf('options') >= 0;

  if (!isUnknowItent) {
    commands.value = commands.value ? commands.value : '';
  }
  inputJson.value = inputJson.value ? inputJson.value : '{}';

  const reply = JSON.parse(inputJson.value);
  reply.options = reply.options ? reply.options.concat({ ...optionList }) : [{ ...optionList }];

  /** Atualiza lista de opções da resposta automática */
  const updateOptions = (optionsChanged) => {
    const options = optionsChanged.filter((o) => o.label !== '' || o.value !== '');
    const replyChanged = {
      ...reply,
      options,
    };

    props.updateParameter({
      ...inputJson,
      value: JSON.stringify(replyChanged),
    });
  };

  /** Atualiza a mesagem da resposta automática */
  const updateMessage = (e) => {
    const options = reply.options.filter((o) => o.label !== '' || o.value !== '');
    const replyChanged = {
      ...reply,
      options,
      text: e.target.value,
    };

    props.updateParameter({
      ...inputJson,
      value: JSON.stringify(replyChanged),
    });
  };

  useEffect(() => {
    const helperContent = (
      <div>
        {ReactHtmlParser(`${props.component.description} Nesse componente podem ser configurados:`)}
        <ul>
          <li>{ReactHtmlParser(inputJson.parameter.hint)}</li>
        </ul>
      </div>
    );
    props.setHelperContent(<div>{helperContent}</div>);
  }, []);

  let accordionItemText = <br />;
  let accordionItemOptions = <br />;

  if (shouldRenderInputJsonText) {
    accordionItemText = (
      <AccordionItem active>
        <div>Mensagem automática</div>
        <div className={styles.ComponentSubList}>
          <TextArea
            value={reply.text}
            onChange={updateMessage}
            height={60}
            placeholder="Digite"
          />
        </div>
      </AccordionItem>
    );
  }

  if (shouldRenderInputJsonOptions) {
    accordionItemOptions = (
      <AccordionItem active title={ReactHtmlParser(inputJson.parameter.hint)}>
        <div>Opções de respostas</div>
        <div className={styles.ComponentSubList}>
          <OptionsListInput
            options={reply.options}
            updateOptions={updateOptions}
          />
        </div>
      </AccordionItem>
    );
  }

  return (
    <Accordion>

      {accordionItemText}

      {accordionItemOptions}

      {props.localizationAccordionItem || null}
    </Accordion>
  );
};

export default AutomaticReply;
